import { useState, useEffect, useRef } from "react";
import BannerStyle from "../assets/stylesheets/BannerSlider.module.css";

import Logger from "../utils/logger";

const log = Logger.create("BannerSlider");

const BannerSlider = ({ slides = [], delay = 5000 }) => {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!slides.length) return; // slides가 없으면 타이머 작동 안 함

    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(
      () => setIndex((prevIndex) => (prevIndex + 1) % slides.length),
      delay
    );
    return () => clearTimeout(timeoutRef.current);
  }, [index, slides, delay]);

  if (!slides.length) return null; // slides 없으면 아무 것도 렌더 안함

  return (
    <div className={BannerStyle["main-banner"]}>
      <div
        className={BannerStyle["banner-slider"]}
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {slides.map((slide, i) => (
          <div className={BannerStyle["banner-slide"]} key={i}>
            <img
              className={BannerStyle["banner-background"]}
              src={slide.image}
              alt={`banner-${i}`}
            />
            <div className={BannerStyle["banner-overlay"]}>
              <h2>{slide.title}</h2>
              <p>{slide.description}</p>
              {slide.buttonText && slide.link && (
                <a href={slide.link} className={BannerStyle["banner-btn"]}>
                  {slide.buttonText}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BannerSlider;
